module.exports = __webpack_public_path__ + "img/Central European Free Trade Agreement.1e47b2ec.svg";